/* eslint-disable import/newline-after-import */
/* eslint-disable global-require */
// import { csvParse } from 'd3-dsv';
import { formatLocale } from 'd3-format';
// import { Logger } from './logger';

let strings = {};
let LANG = 'en';

export function setTranslations(ts) {
  strings = { ...strings, ...ts };
}

export function setLanguage(l) {
  LANG = l;
}

export function getLanguage() {
  return LANG;
}

const translatables = [];

const printTranslatables = () => {
  let out = '';
  translatables.forEach((t) => {
    out += `${JSON.stringify(t)},\n`;
  });
  console.log(out);
};

export function translate(x) {
  if (window.COLLECT_TRANSLATABLES) {
    window.TRANSLATABLES = printTranslatables;
    if (x !== undefined && translatables.indexOf(x) === -1) {
      translatables.push(x);
    }
  }

  return strings[x] || x;
}

const t = translate;

/* FORMATING DATES */
// we assume only two options. 1: yyyy-mm-dd, 2. dd.mm.yyyy in which dates come
export function getDateFormatFunction(delimiter) {
  const changeFormat = function (str) {
    const stri = str.replace(/\s/g, '');
    let stringArray = stri.split(delimiter);
    stringArray = stringArray.reverse();
    const otherDelimiter = delimiter === '-' ? '.' : '-';
    return stringArray.join(otherDelimiter);
  };
  const keepFormat = function (str) {
    return str.replace(/\s/g, '');
  };

  if (LANG === 'en') {
    if (delimiter === '-') {
      return keepFormat;
    }
    return changeFormat;
  } else if (delimiter === '-') {
    return changeFormat;
  }
  return keepFormat;
}

/* FORMATING NUMBERS */

const lfLikeEN = {
  decimal: '.',
  thousands: ',',
  currencyPre: true,
  noSpaceBeforeOrder: true,
};
const lfLikeIT = { decimal: ',', thousands: '.', currencyPre: false };
const lfLikeES = {
  decimal: ',',
  thousands: '.',
  currencyPre: false,
  noB: true,
};
const lfLikeFR = { decimal: ',', thousands: '\u2009', currencyPre: false };
const lfLikeDE = { decimal: ',', thousands: '.', currencyPre: false };
const lfLikeRU = { decimal: ',', thousands: '\u2009', currencyPre: false };

const languageFormats = {
  en: lfLikeEN,

  es: lfLikeES,
  pt: lfLikeES,

  it: lfLikeIT,
  no: lfLikeIT,

  de: lfLikeDE,

  ru: lfLikeRU,
  pl: lfLikeRU,

  default: lfLikeFR,
};

export function getLanguageFormat() {
  const format = languageFormats[LANG] || languageFormats.default;
  return format;
}

const locales = {};
Object.keys(languageFormats).forEach((l) => {
  const f = languageFormats[l];
  locales[l] = formatLocale({
    decimal: f.decimal,
    thousands: f.thousands,
    grouping: [3],
  });
});

function fixThousandSep(x, sep) {
  const s = x.split(sep);
  if (s.length !== 2) return x;
  if (s[0].length !== 1) return x;
  return x.replace(sep, '');
}

const formatIntDefaultOptions = {
  postfix: '',
  prefix: '',
};

export function formatInt(opts) {
  const o = { ...formatIntDefaultOptions, ...opts };
  const locale = locales[LANG] || locales.default;
  const format = languageFormats[LANG] || languageFormats.default;
  return x =>
    (o.prefix || '') +
    fixThousandSep(locale.format(',d')(x), format.thousands) +
    (o.postfix || '');
}

const formatFloatDefaultOptions = {
  digits: 1,
  postfix: '',
  prefix: '',
  multiplier: 1,
  signed: false,
  decimal: false, // remove trailing zeros
  adaptive: true, // add extra digits for small numbers
};

export function formatFloat(opts) {
  const o = { ...formatFloatDefaultOptions, ...opts };
  const locale = locales[LANG] || locales.default;
  const format = languageFormats[LANG] || languageFormats.default;

  return function (x) {
    let ds = o.digits;
    if (x === '' || x === null || x === undefined) return '';
    if (o.adaptive) {
      // D 2021-04-22 removed the following line, to have 12,8 and 0,3 (instead of 0,31)
      // if (Math.abs(x * o.multiplier) < 1) ds += 1;
      if (Math.abs(x * o.multiplier) < 0.1) ds += 1;
      if (Math.abs(x * o.multiplier) < 0.01) ds += 1;
      if (Math.abs(x * o.multiplier) < 0.001) ds += 1;
    }
    let s = locale.format(`${o.signed ? '+' : ''},.${ds}f`)(x * o.multiplier);
    if (x === 0) s = s.replace('+', '');
    s = fixThousandSep(s, format.thousands);
    if (o.adaptive && s.replace(/0/g, '').replace(format.decimal, '') === '') {
      s = '0';
    }
    if (o.decimal) {
      s = s.replace(new RegExp(`${format.decimal.replace('.', '\\.')}0*$`), '');
      if (s.indexOf(format.decimal) > -1) {
        s = s.replace(/0*$/, '');
      }
    }
    return (o.prefix || '') + s + (o.postfix || '');
  };
}

export function formatFloatK(opts) {
  const format = languageFormats[LANG] || languageFormats.default;
  return formatFloat({
    ...opts,
    multiplier: 1e-3,
    postfix:
      (format.noSpaceBeforeOrder ? '' : '\u00a0') +
      t('k') +
      (opts.postfix || ''),
  });
}

export function formatFloatM(opts) {
  const format = languageFormats[LANG] || languageFormats.default;
  return formatFloat({
    ...opts,
    multiplier: 1e-6,
    postfix:
      (format.noSpaceBeforeOrder ? '' : '\u00a0') +
      t('M') +
      (opts.postfix || ''),
  });
}

export function formatFloatB(opts) {
  const format = languageFormats[LANG] || languageFormats.default;
  if (format.noB) return formatFloatM(opts);
  return formatFloat({
    ...opts,
    multiplier: 1e-9,
    postfix:
      (format.noSpaceBeforeOrder ? '' : '\u00a0') +
      t('B') +
      (opts.postfix || ''),
  });
}

export function formatFloatKVerbose(opts) {
  return formatFloat({
    ...opts,
    multiplier: 1e-3,
    postfix: `\u00a0${t('thousand')}${opts.postfix || ''}`,
  });
}

export function formatFloatMVerbose(opts) {
  return formatFloat({
    ...opts,
    multiplier: 1e-6,
    postfix: `\u00a0${t('million')}${opts.postfix || ''}`,
  });
}

export function formatFloatBVerbose(opts) {
  const format = languageFormats[LANG] || languageFormats.default;
  if (format.noB) return formatFloatMVerbose(opts);
  return formatFloat({
    ...opts,
    multiplier: 1e-9,
    postfix: `\u00a0${t('billion')}${opts.postfix || ''}`,
  });
}

export function formatIntAdaptive(opts = {}) {
  const frmtI = formatInt(opts);
  const frmtM = formatFloatM(opts);
  const frmtB = formatFloatB(opts);
  const frmtK = formatFloatK(opts);

  return function (v) {
    if (v >= 10 ** (9 - opts.digits)) return frmtB(v);
    if (v >= 10 ** (6 - opts.digits)) return frmtM(v);
    if (opts.useK && v >= 10 ** (4 - opts.digits)) return frmtK(v);
    return frmtI(v);
  };
}

export function formatFloatAdaptive(opts = {}) {
  const frmtI = formatFloat(opts);
  const frmtM = formatFloatM(opts);
  const frmtB = formatFloatB(opts);

  return function (v) {
    if (v >= 10 ** (9 - opts.digits) + 1) return frmtB(v);
    if (v >= 10 ** (6 - opts.digits) + 1) return frmtM(v);
    return frmtI(v);
  };
}

export function formatIntAdaptiveVerbose(opts = {}) {
  const frmtI = formatInt(opts);
  const frmtM = formatFloatMVerbose(opts);
  const frmtB = formatFloatBVerbose(opts);

  return function (v) {
    if (v >= 10 ** (9 - opts.digits)) return frmtB(v);
    if (v >= 10 ** (6 - opts.digits)) return frmtM(v);
    return frmtI(v);
  };
}

export function formatFloatAdaptiveVerbose(opts = {}) {
  const frmtI = formatFloat(opts);
  const frmtM = formatFloatMVerbose(opts);
  const frmtB = formatFloatBVerbose(opts);

  return function (v) {
    if (v >= 10 ** (9 - opts.digits)) return frmtB(v);
    if (v >= 10 ** (6 - opts.digits)) return frmtM(v);
    return frmtI(v);
  };
}

const handleCurrency = opts => ({
  ...opts,
  prefix:
    (opts.prefix || '') +
    ((languageFormats[LANG] || languageFormats.default).currencyPre
      ? opts.currency || '€'
      : ''),
  postfix:
    (!(languageFormats[LANG] || languageFormats.default).currencyPre
      ? `\u2009${opts.currency || '€'}`
      : '') + (opts.postfix || ''),
});

export function formatMoneyInt(opts = {}) {
  return formatInt(handleCurrency(opts));
}

export function formatMoneyFloat(opts = {}) {
  return formatFloat(handleCurrency(opts));
}

export function formatMoneyFloatK(opts = {}) {
  return formatFloatK(handleCurrency(opts));
}

export function formatMoneyFloatM(opts = {}) {
  return formatFloatM(handleCurrency(opts));
}

export function formatMoneyFloatB(opts = {}) {
  return formatFloatB(handleCurrency(opts));
}

export function formatMoneyIntAdaptive(opts = {}) {
  return formatIntAdaptive(handleCurrency(opts));
}

export function formatMoneyFloatAdaptive(opts = {}) {
  return formatFloatAdaptive(handleCurrency(opts));
}

export function formatMoneyFloatKVerbose(opts = {}) {
  return formatFloatKVerbose(handleCurrency(opts));
}

export function formatMoneyFloatMVerbose(opts = {}) {
  return formatFloatMVerbose(handleCurrency(opts));
}

export function formatMoneyFloatBVerbose(opts = {}) {
  return formatFloatBVerbose(handleCurrency(opts));
}

export function formatMoneyIntAdaptiveVerbose(opts = {}) {
  return formatIntAdaptiveVerbose(handleCurrency(opts));
}

export function formatMoneyFloatAdaptiveVerbose(opts = {}) {
  return formatFloatAdaptiveVerbose(handleCurrency(opts));
}
